const config = {
    development: {
        api: {
            baseURL: process.env.REACT_APP_API_BASE_URL
        }
    },
    production: {
        api: {
            baseURL: process.env.REACT_APP_API_BASE_URL
        },
    },
};

export default config[process.env.NODE_ENV];
